import { Form, Button, Typography, Row, Col } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import CustomInput from "../CustomInput/Input";
import {
  EMPTY_REFERENCE_LINK,
  getLinkDescriptionRules,
  getLinkUrlRules,
} from "../../helpers/referenceLinks";
import "./ReferenceLinksFormList.scss";

const { Text } = Typography;

const ReferenceLinksFormList = ({ listName = "otherLinks" }) => (
  <Form.List name={listName} initialValue={[EMPTY_REFERENCE_LINK]}>
    {(fields, { add, remove }) => (
      <div className="ref-links-form-list">
        <div className="ref-link-header">
          <Text className="ref-link-header-label">
            Additional Reference Links
          </Text>
          <Text className="ref-link-header-label">Link Description</Text>
          <span className="ref-link-action-header" aria-hidden="true" />
        </div>

        {fields.map((field) => (
          <Row gutter={[24, 0]}>
            <Col xs={24} md={11}>
              <CustomInput
                name={[field.name, "url"]}
                placeholder="Enter link (https://...)"
                dependencies={[[listName, field.name, "description"]]}
                rules={getLinkUrlRules(field.name, listName)}
              />
            </Col>

            <Col xs={24} md={11}>
              <CustomInput
                name={[field.name, "description"]}
                maxLength={500}
                showCount
                placeholder="Enter link description (10-500 characters)"
                dependencies={[[listName, field.name, "url"]]}
                rules={getLinkDescriptionRules(field.name, listName)}
              />
            </Col>

            <Col xs={24} md={2}>
              {fields.length > 1 && (
                <Button
                  type="text"
                  aria-label="Remove link"
                  className="ref-link-remove-btn"
                  icon={<MinusCircleOutlined />}
                  onClick={() => remove(field.name)}
                />
              )}
            </Col>
          </Row>
        ))}

        <Button
          type="dashed"
          icon={<PlusOutlined />}
          onClick={() => add({ ...EMPTY_REFERENCE_LINK })}
          block
          className="ref-link-add-btn"
        >
          Add Link
        </Button>
      </div>
    )}
  </Form.List>
);

export default ReferenceLinksFormList;
